import { CmsApi } from "../cms_api";
import { draw_assets_menu } from "./menu/AssetsMenu";
import { draw_attachments_menu } from "./menu/AttachmentsMenu";
import { draw_buildings_menu } from "./menu/BuildingsMenu";
import { draw_findings_menu } from "./menu/FindingsMenu";
import { draw_floors_menu } from "./menu/FloorsMenu";
import { draw_pushpin_menu } from "./menu/PushpinMenu";
import { draw_workorders_menu } from "./menu/WorkordersMenu";
import { Id_floor } from "../api/Identifiers";
import { Keys } from "../redux/Datastore";
import { map_redraw_layers } from "./map/map_area";
import { State, get_state, prev_state, did_any_change, did_change } from "../redux/State";
import { toggle_create_finding_mode } from "../cms_view";
import { update_drawings_buttons_temp } from "./map/MapButtons";
import jQuery from "jquery";
import { Cookie } from "../Cookies";
import { draw_cluster_toggle_menu } from "./menu/ClusterToggleMenus";

export function listener() {

    let old_state: State = prev_state();
    let state: State = get_state();



    if (did_change(Keys.STATE_CREATING_FINDING)) {
        toggle_create_finding_mode(state);
    }
    if (did_change(Keys.KEY_BUILD_ID)) {
        let old_build_id = Cookie.read(Keys.KEY_BUILD_ID, "UNDEFINED");
        if (state.build_id != old_build_id){
            console.debug(`System build has changed: old: ${old_build_id}, new:${state.build_id}. CLEAR COOKIES`); // AWH TODO: implement this outside of the state in an init routine. with a promise
        // erase cookies here.
        }else{
            console.debug(`Cookies match build ${state.build_id}`);
        // load cookies here.
        }
       
    }

    if (did_change(Keys.ID_FLOOR)) {
        let id_floor: Id_floor = state.id_floor;
        //        var id_floor = new_imm_state.get(KEY_ID_FLOOR)
        //        data_assets = new_imm_state.get(KEY_DATA_ASSETS).toJS()
        //        downloaded_assets = new_imm_state.get(KEY_DOWNLOADED_ASSET_FLOORS).toJS();
        //        if (!_.includes(downloaded_assets, id_floor)) {
        //            fetchAssetsData(id_floor)
        //        }

        // var downloaded_findings = state.downloaded_findings_floors; (.get(KEY_DOWNLOADED_FINDING_FLOORS);
        // if(downloaded_findings){
        //     downloaded_findings=downloaded_findings.toJS();
        // } else{
        //     downloaded_findings=[]
        // }
        if (!state.downloaded_findings_floors.includes(id_floor)) {
            CmsApi.api_roundingdrawinglocations_getfindingsbyfloor(id_floor);

        }
        // if (!_.includes(downloaded_findings, id_floor)) {
        //     fetchFindingsData(id_floor)
        // }
    }
    if (did_any_change([Keys.ID_BUILDING, Keys.ID_FLOOR, Keys.HASH_DATA_FLOORPLANS, Keys.ID_DRAWING])) {
        update_drawings_buttons_temp();
    }


    if (did_any_change([Keys.STATE_FETCHING_FINDINGS])) {
        if (state.fetching_findings) {
            jQuery("#loading_findings").show();
        } else {
            jQuery("#loading_findings").hide();
        }
    }

    if (did_any_change([Keys.STATE_PRINTING_FINDINGS])){
        if (state.printing_findings){
            jQuery("#printing_findings").show();
        }
        else {
            jQuery("#printing_findings").hide();
        }
    }

    draw_assets_menu();
    draw_buildings_menu();
    draw_findings_menu();
    draw_floors_menu();
    draw_pushpin_menu();
    draw_workorders_menu();
    draw_attachments_menu();
    draw_cluster_toggle_menu();
    
    map_redraw_layers();
}